import axios from "axios";

const resourcesBaseUrl = process.env.REACT_APP_GITO_API_URL + '/resources';
const telemetryBaseUrl = process.env.REACT_APP_GITO_API_URL + '/telemetry';


const gridAreaBaseUrl = `${resourcesBaseUrl}/GridArea`;
const taxBaseUrl = `${resourcesBaseUrl}/NationalEnergyTaxRate`;
const calculateBaseUrl = `${telemetryBaseUrl}/GridCost`;
const MAX_GRID_COST_SITES = 3;

//const gridAreaBaseUrl = "https://localhost:7241/GridArea";
//const taxBaseUrl = "https://localhost:7241/NationalEnergyTaxRate";
//const calculateBaseUrl = "https://localhost:7241/GridCost";

const authHeaders = (apiAccessToken) => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${apiAccessToken}`,
});

function apiError(error, fallback) {
    throw new Error(error.response?.data?.detail || error.response?.data?.title || fallback);
}

export async function getAllGridAreas(apiAccessToken) {
    try {
        const response = await axios.get(`${gridAreaBaseUrl}/get-all-grid-areas`, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to fetch grid areas");
    }
}

export async function getGridArea(gridAreaPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${gridAreaBaseUrl}/get-grid-area/${gridAreaPublicId}`, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to fetch grid area");
    }
}

export async function createGridArea(dto, apiAccessToken) {
    try {
        const response = await axios.post(`${gridAreaBaseUrl}/create-grid-area`, dto, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to create grid area");
    }
}

export async function updateGridArea(dto, apiAccessToken) {
    try {
        const response = await axios.put(`${gridAreaBaseUrl}/update-grid-area`, dto, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to update grid area");
    }
}

export async function getAllGridAreaTariffs(apiAccessToken, gridAreaPublicId, gridVoltageLevel, activeOn) {
    try {
        const params = {};
        if (gridAreaPublicId) {
            params.gridAreaPublicId = gridAreaPublicId;
        }
        if (gridVoltageLevel) {
            params.gridVoltageLevel = gridVoltageLevel;
        }
        if (activeOn) {
            params.activeOn = activeOn;
        }
        const response = await axios.get(`${gridAreaBaseUrl}/get-all-grid-area-tariffs`, {
            headers: authHeaders(apiAccessToken),
            params,
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to fetch grid area tariffs");
    }
}

export async function getGridAreaTariff(gridAreaTariffPublicId, apiAccessToken) {
    try {
        const response = await axios.get(
            `${gridAreaBaseUrl}/get-grid-area-tariff/${gridAreaTariffPublicId}`,
            {
                headers: authHeaders(apiAccessToken),
            }
        );
        return response.data;
    } catch (error) {
        apiError(error, "Failed to fetch grid area tariff");
    }
}

export async function createGridAreaTariff(dto, apiAccessToken) {
    try {
        const response = await axios.post(`${gridAreaBaseUrl}/create-grid-area-tariff`, dto, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to create grid area tariff");
    }
}

export async function updateGridAreaTariff(dto, apiAccessToken) {
    try {
        const response = await axios.put(`${gridAreaBaseUrl}/update-grid-area-tariff`, dto, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to update grid area tariff");
    }
}

export async function deleteGridAreaTariff(gridAreaTariffPublicId, apiAccessToken) {
    try {
        await axios.delete(`${gridAreaBaseUrl}/delete-grid-area-tariff/${gridAreaTariffPublicId}`, {
            headers: authHeaders(apiAccessToken),
        });
    } catch (error) {
        apiError(error, "Failed to delete grid area tariff");
    }
}

export async function getAllNationalEnergyTaxRates(apiAccessToken) {
    try {
        const response = await axios.get(`${taxBaseUrl}/get-all-national-energy-tax-rates`, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to fetch national energy tax rates");
    }
}

export async function createNationalEnergyTaxRate(dto, apiAccessToken) {
    try {
        const response = await axios.post(`${taxBaseUrl}/create-national-energy-tax-rate`, dto, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to create national energy tax rate");
    }
}

export async function calculateGridCost(request, apiAccessToken) {
    if ((request?.sitePublicIds || []).length > MAX_GRID_COST_SITES) {
        throw new Error(`Select no more than ${MAX_GRID_COST_SITES} sites.`);
    }

    try {
        const response = await axios.post(`${calculateBaseUrl}/calculate-grid-cost`, request, {
            headers: authHeaders(apiAccessToken),
        });
        return response.data;
    } catch (error) {
        apiError(error, "Failed to calculate site costs");
    }
}
